<template>
  <div v-if="model">
    <Checkout />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import isBnn from '@/config/isBnn'

export default {
  components: {
    Checkout: () => import('@/components/studio7/Checkout'),
  },

  computed: {
    ...mapState({
      campaign: state => state.campaign.current,
      model: state => state.model.selectModel,
      selectSKU: state => state.model.selectSKU,
    }),

    isVip() {
      return this.campaign?.data?.is_vip_preview ?? false
    },

    buName() {
      return isBnn ? 'BaNANA' : 'Studio7'
    },

    metaTitle() {
      return `เปิดจอง ${this.campaign?.data?.name ||
        ''} รับสิทธิพิเศษมากมายที่ ${this.buName}`
    },

    metaDescription() {
      return `เปิดจอง ${this.campaign?.data?.name ||
        ''} จองก่อนได้ก่อนที่ ${
        this.buName
      } Online เปิดจอง iPhone iPhone 17, iPhone Air, iPhone 17 Pro และ iPhone 17 Pro Max วันที่ 12 กันยายน 2568 เวลา 19.00 น. วางขายจริง 19 กันยายน 2568 สมัคร 7 Club+ รอรับสิทธิ์ได้เลย`
    },
  },

  provide() {
    return {
      isVip: () => this.isVip ?? false,
    }
  },

  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [{ name: 'description', content: this.metaDescription }],
    }
  },

  async mounted() {
    if (!this.model) {
      this.$router
        .push({
          name: 'ProductDetail',
          params: {
            slug: this.$route.params?.slug,
          },
        })
        .catch(() => true)
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })

    // fetch product payment option again to ensure the latest data is retrieved
    await this.$store.dispatch(
      'paymentType/fetchProductPaymentOptions',
      {
        campaign: this.$route.params?.slug,
        sku: this.selectSKU?.sku ?? this.$route.query?.sku,
        ...(this.$route.query?.code && {
          code: this.$route.query?.code,
        }),
        ...(this.$route.query?.branch_code && {
          branch_code: this.$route.query?.branch_code,
        }),
      },
    )

    // fetch banner
    if (this.isVip) {
      await this.$store.dispatch(
        'staticPage/getStaticPage',
        'vip-marketing-banner',
      )
    }

    // if history state has 'member_request_key' remove it from the history state
    if (window.history.state && window.history.state.back) {
      // Remove 'member_request_key' from the history state
      const newState = { ...window.history.state }
      delete newState.back.query.member_request_key
      window.history.replaceState(newState, '')
    }
  },
}
</script>
